import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';

const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  // return response.data.result.assets.map((v) => {
  //   return {
  //     ...v.content.content,
  //     latestModifiedDate: v.metadata.LatestModifiedDate,
  //     id: v.id,
  //   };
  // });
  return {
    ...response.data.result.assets[0].content.content,
    latestModifiedDate: response.data.result.assets[0].metadata.LatestModifiedDate,
    id: response.data.result.assets[0].id,
  };
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = () => {
  const queryParameters = {
    prefixPath: config.lscsPath,
    q: `((TeamSite/Templating/DCR/Type:${config.pageType.category}))`,
    start: null,
    max: null,
    projectName: config.cmsProjectName,
    enableDate: false,
  };
  const url = CMSAPI_INDEX(queryParameters);
  return axiosAdapter({
    url,
  });
};

const getCategory = () => {
  return (dispatch) => {
    dispatch(requestFetch());
    return fetchData()
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getCategory };
